import { useTranslation } from "react-i18next";
import { ButtonNew as Button } from "components/buttonNew";
import { WebsiteBuilderPanelContent } from "pages/secure/facility/websiteBuilder/editor/shell/panel/content/WebsiteBuilderPanelContent";
import { TWebsiteBuilderHandleUpdateState, TWebsiteBuilderHandleDebouncedUpdateState } from "pages/secure/facility/websiteBuilder/editor/hooks/debouncedUpdate/useWebsiteBuilderDebouncedUpdate";
import { IWebsiteBuilderMarqueeLinkItem, IWebsiteBuilderMarqueeSettings } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderMarquee";
import React from "react";
import { WebsiteBuilderLinkSettingsFields } from "../../element/link/LinkSettings";

interface IMarqueeSettingsEditLinkViewProps {
  item: IWebsiteBuilderMarqueeLinkItem;
  handleUpdateState: TWebsiteBuilderHandleUpdateState<IWebsiteBuilderMarqueeSettings>;
  handleDebouncedUpdateState: TWebsiteBuilderHandleDebouncedUpdateState<IWebsiteBuilderMarqueeSettings>;
  onBack: () => void;
  closeSettings: () => void;
}

export function MarqueeSettingsEditLinkView(props: IMarqueeSettingsEditLinkViewProps) {
  const { item, handleUpdateState, handleDebouncedUpdateState, onBack, closeSettings } = props;

  const { t } = useTranslation();

  return (
    <WebsiteBuilderPanelContent
      title={t("Edit link")}
      closePanel={closeSettings}
      sections={[
        <WebsiteBuilderLinkSettingsFields
          key="edit-link"
          settings={item.settings}
          showHoverSettings={false}
          onChange={settings =>
            handleUpdateState(prev => ({
              ...prev,
              items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "link"
                ? { ...prevItem, settings }
                : prevItem),
            }))
          }
          onDebouncedChange={settings =>
            handleDebouncedUpdateState(prev => ({
              ...prev,
              items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "link"
                ? { ...prevItem, settings }
                : prevItem),
            }))
          }
        />,
      ]}
      footer={(
        <Button size="small" type="secondary" onClick={onBack} block>
          {t("Go back")}
        </Button>
      )}
    />
  );
}